import { PermissionCode } from '@atlas-frontend/sdk';
import { SampleDataObjectType } from '../sample/SampleSearch';
import { useHasPermissionToManageSample } from '../sample/useHasPermissionToManageSample';

export const useHasPermissionToManageInputData = (
  id: number,
  sampleType: SampleDataObjectType
) =>
  useHasPermissionToManageSample(
    id,
    sampleType,
    PermissionCode.INPUT_DATA_MANAGE
  );
